export const language_vn = {
  error: "Đã xảy ra lỗi, vui lòng thử lại sau!!",

  success_source_lead: "Cập nhật nguồn thành công",
  success_customer_group_type: "Cập nhật loại nhóm thành công",
  source_lead: "Quản lý nguồn",
  save: "Lưu",
  import_excel: "Chào mừng bạn đến với import excel",
  download_template: "Tải Mẫu Import",
  close: "Đóng",
  save_data_import: "Lưu dữ liệu import",
  requested: "Đã yêu cầu",
  completed: "Đã hoàn thành",
  completed: "Đã hoàn thành",
  canceled: "Đã huỷ",
  historyCall: "Lịch sử cuộc gọi",
  invitedTotal: "Tổng số người đã mời",
  salesTotal: "Tổng doanh số",
  referral: "Giới thiệu",
  chooseGroup: "Chọn đội sales",
  chooseEmployee: "Chọn nhân viên sales",

  USER_INACTIVE: "inactive",
  USER_ACTIVE: "active",
  USER_VERIFYING: "verifying",
  USER_VERIFIED: "verified",
  active: "Hoạt động",
  inActive: "Chưa hoạt động",
  verifying: "Đang xác thực",
  verified: "Đã xác thực",
};
